import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import { prefix } from '../../utils/string';
import { addEvent, removeEvent, addClass, removeClass, offset } from '../../utils/dom';
import { openCart, openMenu } from '../../actions/environment';
import s from './Logo.scss';

class Logo extends Component {
	constructor(props) {
		/* Called before mounting. Initialize state */
		super(props);

		this.state = {
			headerHeight: null,
		};
	}

	componentDidMount() {
		const { headerElement, cartIsOpen, menuIsOpen } = this.props;

		const $html = document.querySelector('html');
		const logoAspectRatio = 0.19868637;
		let headerHeight = (document.body.clientWidth - 40) * logoAspectRatio;
		let menuOffset = offset(headerElement.current).top + headerHeight;

		let isScrolled = false;
		let headerIsFixed = false;
		let firstScroll = true;

		const resizeEvent = () => {
			headerHeight = (document.body.clientWidth - 40) * logoAspectRatio;
			menuOffset = offset(headerElement.current).top + (firstScroll ? headerHeight : 0);
			this.setState({
				headerHeight: firstScroll ? 0 : headerHeight,
			});
		};

		addEvent(window, 'resize.logoHeader', () => {
			window.requestAnimationFrame(resizeEvent);
		});

		const scrollEvent = () => {
			const top = window.pageYOffset || document.documentElement.scrollTop;
			menuOffset = offset(headerElement.current).top + (firstScroll ? headerHeight : 0);

			if (cartIsOpen === 1) this.props.openCart(false);
			if (menuIsOpen) this.props.openMenu();

			// make logo sticky when level with header.
			if (firstScroll && top > offset(headerElement.current).top && top < menuOffset - (headerHeight / 2)) {
				const logoScrolled = top - offset(headerElement.current).top;
				this.setState({
					headerHeight: logoScrolled,
				});
			} else if (firstScroll && top >= menuOffset - (headerHeight / 2)) {
				headerIsFixed = true;
				addClass($html, 'headerIsFixed');
				addClass($html, 'headerIsMinimized');

				const logoScrolled = top - offset(headerElement.current).top;
				if (logoScrolled < headerHeight) {
					this.setState({
						headerHeight: logoScrolled,
					});
				} else {
					firstScroll = false;
					this.setState({
						headerHeight,
					});
				}
			} else if (!headerIsFixed && top >= menuOffset) {
				headerIsFixed = true;
				addClass($html, 'headerIsFixed');
			} else if (headerIsFixed && top < menuOffset) {
				headerIsFixed = false;
				removeClass($html, 'headerIsFixed');
			}

			if (top > 0 && !isScrolled) {
				addClass($html, 'is-scrolled');
				isScrolled = true;
			} else if (top === 0) {
				removeClass($html, 'is-scrolled');
				isScrolled = false;
			}
		};

		addEvent(window, 'scroll.logoHeader', () => {
			window.requestAnimationFrame(scrollEvent);
		});

		resizeEvent();
		scrollEvent();
	}

	componentWillUnmount() {
		removeEvent(window, 'scroll.logoHeader');
		removeEvent(window, 'resize.logoHeader');
	}

	render() {
		const { setup } = this.props;
		const { headerHeight } = this.state;

		return (
			<Link className={[s.logo].join(' ')} to={prefix(setup, '')}>
				<svg xmlns="http://www.w3.org/2000/svg" width="1218" height="222" viewBox="0 0 1218 222" aria-labelledby="title" style={(headerHeight !== null ? { marginTop: `-${headerHeight}px` } : { marginTop: 0 })}>
					<title>APLACE logo</title>
					<g fill="#231F20" transform="translate(0 -.007)">
						<path d="M151.323996 96.2914776 109.898931 198.277475 68.152665 96.2914776 151.323996 96.2914776ZM89.5713311 217.549475 130.227063 217.549475 219.479995 4.0159999 188.669329 4.0159999 159.935996 73.6534782 59.5406652 73.6534782 30.8103992 4.0159999 0 4.0159999 89.5713311 217.549475M327.494658 96.7014776C359.922658 96.7014776 379.501324 114.567077 379.501324 145.105476 379.501324 175.316142 359.614658 193.508142 324.130659 193.508142L265.393327 193.508142 265.393327 96.7014776 327.494658 96.7014776ZM237.858661 217.549475 324.130659 217.549475C373.046657 217.549475 405.490657 190.585475 405.490657 145.105476 405.490657 98.9748109 373.046657 73.7389448 324.130659 73.7389448L265.393327 73.7389448 265.393327 4.0159999 237.858661 4.0159999 237.858661 217.549475" transform="matrix(1 0 0 -1 0 221.565)" />
						<polyline points="429.236 217.549 456.74 217.393 456.74 27.946 581.841 28.1 581.841 4.016 429.236 4.016 429.236 217.549" transform="matrix(1 0 0 -1 0 221.565)" />
						<path d="M751.269315,96.2914776 L709.843982,198.277475 L668.097317,96.2914776 L751.269315,96.2914776 Z M689.515983,217.549475 L730.171982,217.549475 L819.425313,4.0159999 L788.614647,4.0159999 L759.881314,73.6534782 L659.485317,73.6534782 L630.755984,4.0159999 L599.945318,4.0159999 L689.515983,217.549475" transform="matrix(1 0 0 -1 0 221.565)" />
						<polyline points="1055.183 217.549 1212.917 217.549 1212.917 194.911 1082.356 194.911 1082.356 123.544 1193.301 123.544 1193.301 99.66 1082.356 99.66 1082.356 27.831 1217.471 27.831 1217.471 4.016 1055.183 4.016 1055.183 217.549" transform="matrix(1 0 0 -1 0 221.565)" />
						<path d="M923.383977,22.9546661 C874.113311,22.9546661 836.455979,59.9838652 836.455979,110.783864 C836.455979,161.583996 874.113311,198.611995 923.383977,198.611995 C961.525309,198.611995 991.269309,184.193329 1002.71331,142.65733 L1028.24797,147.106663 C1016.28397,196.590662 974.707976,221.566661 923.383977,221.566661 C858.199979,221.566661 810.15198,175.049329 810.15198,110.783864 C810.15198,46.5171988 858.199979,2.84217094e-14 923.383977,2.84217094e-14 C974.707976,2.84217094e-14 1016.28397,24.9759994 1028.24797,74.4598648 L1002.71331,78.9093314 C991.269309,37.3734657 961.525309,22.9546661 923.383977,22.9546661" transform="matrix(1 0 0 -1 0 221.567)" />
					</g>
				</svg>
			</Link>
		);
	}
}

const mapState = (state, props) => ({ ...props });

export default hot(module)(connect(mapState, { openCart, openMenu })(Logo));
